module.exports = __webpack_public_path__ + "media/images/flags/16/Morocco-f1037ba0d58e0438ebd2be3c07f9f8a1.png";